import type { EventRule } from "../lib/project-tracking";

/**
 * Meta display of one page-rule row (TASK-254). The option `meta_hq_only` changes what the
 * rule reports: HQLead + option goes to Meta as "Lead" (table row "Lead"), Lead + option never
 * goes to Meta; everything else follows its own type. Mirrors the worker (capi-dispatch.ts).
 */
type GoesToMeta = (eventType: string) => boolean;

const lead = (r: EventRule) => r.event_type.trim() === "Lead" && r.meta_hq_only === true;

export function ruleOnMeta(r: EventRule, goesToMeta: GoesToMeta): boolean {
  if (r.meta_hq_only === true && r.event_type.trim() === "HQLead") return goesToMeta("Lead");
  return !lead(r) && goesToMeta(r.event_type);
}

export function RulePixelBox({
  rule: r,
  goesToMeta,
  onChange,
}: {
  rule: EventRule;
  goesToMeta: GoesToMeta;
  onChange: (patch: Partial<EventRule>) => void;
}) {
  const onMeta = ruleOnMeta(r, goesToMeta);
  return (
    <label
      className={`flex items-center gap-1 text-xs ${onMeta ? "text-text-secondary" : "text-text-tertiary/50"}`}
      title={
        lead(r)
          ? "Dieser Lead geht nicht an Meta, der Pixel bleibt aus"
          : onMeta
            ? undefined
            : "Zuerst oben in „Welche Events an Meta?“ aktivieren"
      }
    >
      <input
        type="checkbox"
        checked={r.browser && !lead(r)}
        disabled={!onMeta}
        onChange={(e) =>
          onChange(e.target.checked ? { browser: true } : { browser: false, pixel_confirm: false })
        }
      />{" "}
      Auch im Browser als Pixel feuern
    </label>
  );
}

export function RuleMetaLine({ rule: r, goesToMeta }: { rule: EventRule; goesToMeta: GoesToMeta }) {
  const onMeta = ruleOnMeta(r, goesToMeta);
  const type = r.event_type.trim();
  const reported = r.meta_hq_only === true && type === "HQLead" ? "Lead" : r.event_type;
  return (
    <>
      {onMeta ? (
        <span className="w-full text-[10px] text-success">
          → Meta CAPI (über Event-Routing){r.browser ? " + Pixel" : ""}
        </span>
      ) : lead(r) ? (
        <span className="w-full text-[10px] text-text-tertiary">
          Dieser Lead geht nicht an Meta (Option „An Meta nur HQ-Leads als Lead melden“).
        </span>
      ) : (
        <span className="w-full text-[10px] text-warning">
          „{reported || "Dieses Event"}“ geht aktuell nicht an Meta — oben in der Tabelle aktivieren.
        </span>
      )}
      {type === "HQLead" && r.meta_hq_only !== true && r.browser && !goesToMeta("HQLead") && (
        <span className="w-full text-[10px] text-warning">
          Der Pixel meldet „HQLead“ an Meta, der Server nicht.
        </span>
      )}
    </>
  );
}
